import { AhooksInfiniteScrollFrame } from "@/components/AhooksInfiniteScrollFrame";
import { FilterLayout } from "@/components/FilterLayout";
import { RootHeader } from "@/components/RootHeader";
import { orderStatusList } from "@/constants/order/status";
import { useUserAuthContext } from "@/routes/routesAuths/userAuth";
import { PullToRefresh, SafeArea, Tabs } from "antd-mobile";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AmountOrder } from "./components/AmountOrder";
import { OrderItem } from "./components/OrderItem";
import styles from "./index.module.scss";
import { useSetup } from "./logic";
import { ContentTabs } from "./components/ContentTabs";
import { ErType } from "@/constants/order/key";

const statusList = [
  {
    title: "",
    key: "status",
    multiple: true,
    items: orderStatusList.map((item) => ({
      text: item.text,
      value: item.key,
    })),
  },
];

export const PageNormalOrders = () => {
  const logic = useSetup({pageActiveKey: 'normal'});
  const navigate = useNavigate();
  const { user } = useUserAuthContext();

  const [order, setOrder] = useState<"asc" | "desc">("desc");
  const onSearch = (newParams: any) => {
    logic.paramsRef.current = { ...logic.paramsRef.current, ...newParams };
    logic.infiniteList.reload();
  };

  const onSubmit = (filters: Record<string, string[]>) => {
    // setActiveKey("");
    onSearch({
      // identity: "",
      status: filters.status.length ? filters.status : undefined,
    });
  };

  useEffect(() => {
    onSearch({
      order,
      identity: logic.activeKey ? logic.activeKey : undefined,
    });
  }, [order, logic.activeKey]);

  return (
    <article className={styles.page} ref={logic.scollableRef}>
      <PullToRefresh onRefresh={() => logic.infiniteList.reloadAsync()}>
        
        <section>
          <RootHeader title="我的订单" />
        </section>
        <section>
          <div className={styles.bg}>
            <div className={styles.text}>
              <div className={styles.title}>我的订单</div>
              <div className={styles.desc}>感谢您使用VipPay</div>
            </div>
            <div className={styles.bg_img}></div>
          </div>
        </section>
        <ContentTabs active={'normal'} />
        <section className={styles.filter}>
          <Tabs
            className={styles.tabs}
            activeKey={logic.activeKey}
            onChange={(key) => logic.setActiveKey(key)}
          >
            <Tabs.Tab title="全部" key="" />
            <Tabs.Tab title="买入" key="buyer" />
            <Tabs.Tab title="卖出" key="seller" />
          </Tabs>
          <FilterLayout
            items={statusList as any}
            filters={{ status: logic.params.status || [] }}
            onChange={onSubmit}
          >
            <span>排序方式 </span>
            {/* <AmountOrder order={order} onChange={setOrder} /> */}
          </FilterLayout>
        </section>
        <section className={styles.content}>
          <AhooksInfiniteScrollFrame {...logic.infiniteList}>
            {logic.infiniteList.data?.list.map((order) => {
              // TODO
              const isSeller =
                user.userId === order.sellerId;
              return (
                <OrderItem
                  order={order}
                  user={user}
                  key={order.orderId}
                  onClick={() =>
                    navigate(
                      `/${isSeller ? "sell_trading" : "buy_trading"}/${
                        order.orderId
                      }?m=${order.sellerType ===ErType.Business ?1:0}`
                    )
                  }
                />
              );
            })}
          </AhooksInfiniteScrollFrame>

          <div className={styles.whitespace}></div>
          <SafeArea position="bottom" />
        </section>
      </PullToRefresh>
    </article>
  );
};
